import {
  ApiRequestLogResponse,
  ApiRequestLogGetResponse
} from "../pages/shared/entities/ApiRequestLogResponse";
import RequestService from "./RequestService";

class ApiRequestLogService {
  public static getList(
    page: number,
    pagesize?: number
  ): Promise<ApiRequestLogResponse | Error> {
    return RequestService.post("/apirequestlog/list", { page, pagesize });
  }
  public static get(id: number): Promise<ApiRequestLogGetResponse | Error> {
    return RequestService.post("/apirequestlog/get", { id });
  }
}
export default ApiRequestLogService;
